import { documentReady } from "../Utility/utils";

let shouldTrackMouse = false;

function initializeMouseTracker(shouldInit = true) {
  let [mX, mY, toX, toY] = [0, 0, 0, 0];

  const mouseCordinates = (e) => {
    mX = e.pageX;
    mY = e.pageY;
  };

  if(shouldTrackMouse){
    const followSpeed = 0.12;

    document.body.addEventListener( 'mousemove', mouseCordinates);

    //track the mouse, but you know, kind of sneak up on it
    const updateMouse = () => {
      const dX = mX - toX;
      const dY = mY - toY;

      toX = Math.abs(dX) > 1 ? toX + (dX * followSpeed) : toX;
      toY = Math.abs(dY) > 1 ? toY + (dY * followSpeed) : toY;

      document.documentElement.style.setProperty('--mouse-x', `${toX}px`);
      document.documentElement.style.setProperty('--mouse-y', `${toY}px`);

      if(shouldTrackMouse){
        requestAnimationFrame( updateMouse );
      }
    }

    updateMouse();
  }
  else {
    document.body.removeEventListener( 'mousemove', mouseCordinates);
  }
}

documentReady((event) => {
  const animatedHero = document.querySelector('.hero__animated');
  if(!!animatedHero){
    shouldTrackMouse = true;
    initializeMouseTracker();
  }
  else {
    shouldTrackMouse = false;
  }
});
